var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDuei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xAC\xB4\xEA\xB8\xB0\xEB\xA0\xA5\xED\x95\xB4\xEC\x9A\x94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.7583 28.9167C27.8457 29.9765 19.1826 38.2977 13.8699 47.6514C13.1088 48.9977 12.424 50.3856 11.8186 51.8087C11.4904 52.5608 11.1759 53.3129 10.8751 54.0719C7.16914 63.3367 3.68202 73.3263 8.72809 82.7005C16.2493 96.6627 39.0319 98.8233 55.9068 97.6541C59.4598 97.36 62.9574 96.5919 66.3067 95.3704C69.3622 94.3298 72.2366 92.8187 74.8262 90.8918C82.4022 85.0457 85.0825 77.2168 84.7543 69.9075C84.3303 60.7316 81.0825 54.8035 75.6946 46.9335C71.2365 40.4105 62.211 33.1833 52.8915 30.2432C49.6271 29.1683 46.1894 28.7183 42.7583 28.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.7237 33.9971C22.4428 36.9136 18.748 40.6084 15.8315 44.8892C14.9285 46.1782 14.0932 47.5133 13.329 48.8891C12.9256 49.6139 12.529 50.3524 12.1461 51.084C7.46241 60.0821 4.11204 70.0512 7.65386 79.9929C13.329 95.938 39.2773 101.141 60.8359 97.285",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.2342 28.6013C46.5225 28.358 44.7903 28.2915 43.065 28.403C39.5059 28.6342 35.9999 29.3852 32.6583 30.632",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M74.9444 90.8439C88.9407 79.9039 85.6929 62.1264 77.3512 49.2992C72.3461 41.6139 65.0437 34.4755 55.5874 30.6328",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0003 31.2073C35.6482 31.1041 31.3724 27.356 30.7512 23.1364C40.6871 19.7354 45.1285 29.2526 45.3171 32.6639",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0003 31.2073C35.6482 31.1041 31.3724 27.356 30.7512 23.1364C40.6871 19.7354 45.1285 29.2526 45.3171 32.6639",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.6844 85.9069C18.3895 85.6485 17.1827 85.0621 16.1794 84.2037C15.1762 83.3453 14.4101 82.2437 13.9545 81.0044C13.7719 80.4999 13.4671 80.0485 13.0674 79.6906C12.6677 79.3326 12.1855 79.0793 11.664 78.9532C10.5322 78.6702 9.48038 78.1317 8.58908 77.3791C7.69777 76.6265 6.99072 75.6797 6.52217 74.6113C5.15467 71.7669 10.7819 65.497 13.6469 66.8235C19.3562 69.4832 21.1134 77.0797 23.4313 80.7446C23.8065 81.3241 23.9975 82.0036 23.9791 82.6936C23.9607 83.3837 23.7338 84.0521 23.3283 84.6108C22.9228 85.1695 22.3576 85.5923 21.7072 85.8236C21.0568 86.055 20.3516 86.084 19.6844 85.9069Z",
    fill: "#E6E4E2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3445 77.8522C6.05566 76.6967 3.83347 68.4848 6.23344 58.4952C6.3607 57.7896 6.64491 57.1215 7.06504 56.5404C7.48518 55.9593 8.03051 55.4801 8.66075 55.138C10.1855 54.4064 12.0043 54.7551 13.5427 55.2953C18.5478 57.0594 22.199 60.5944 24.6195 65.2507C26.4724 68.8062 27.4844 73.1822 29.1938 76.6693C30.1692 78.675 31.2245 80.61 32.3595 82.4744C32.6425 82.9278 32.794 83.451 32.7971 83.9855C32.8157 84.6372 32.5972 85.2735 32.1823 85.7765C31.7674 86.2794 31.1841 86.6148 30.5408 86.7205C29.0371 87.0291 27.4737 86.837 26.0895 86.1735C22.6024 84.512 20.2845 81.5035 20.8862 75.4933",
    fill: "#E6E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3445 77.8522C6.05566 76.6967 3.83347 68.4848 6.23344 58.4952C6.3607 57.7896 6.64491 57.1215 7.06504 56.5404C7.48518 55.9593 8.03051 55.4801 8.66075 55.138C10.1855 54.4064 12.0043 54.7551 13.5427 55.2953C18.5478 57.0594 22.199 60.5944 24.6195 65.2507C26.4724 68.8062 27.4844 73.1822 29.1938 76.6693C30.1692 78.675 31.2245 80.61 32.3595 82.4744C32.6425 82.9278 32.794 83.451 32.7971 83.9855C32.8157 84.6372 32.5972 85.2735 32.1823 85.7765C31.7674 86.2794 31.1841 86.6148 30.5408 86.7205C29.0371 87.0291 27.4737 86.837 26.0895 86.1735C22.6024 84.512 20.2845 81.5035 20.8862 75.4933",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8496 84.7647C16.7465 84.4646 15.7613 83.8348 15.0258 82.9596C13.1318 80.6622 12.7625 75.8691 14.2463 71.7324",
    fill: "#E6E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8496 84.7647C16.7465 84.4646 15.7613 83.8348 15.0258 82.9596C13.1318 80.6622 12.7625 75.8691 14.2463 71.7324",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M79.1996 51.1496C77.8827 51.0636 76.5657 51.317 75.3748 51.8855C74.1838 52.4539 73.1586 53.3185 72.3972 54.3964C72.0873 54.8322 71.6749 55.185 71.1965 55.4239C70.7181 55.6628 70.1883 55.7804 69.6537 55.7663C68.4877 55.7435 67.3321 55.9885 66.2756 56.4824C65.2192 56.9764 64.2902 57.7061 63.5601 58.6154C61.4898 61.0019 65.4919 68.0584 68.5864 67.5143C74.7935 66.443 78.2907 60.0418 81.4838 57.0962C81.9927 56.6328 82.3499 56.0266 82.5087 55.3568C82.6674 54.6871 82.6203 53.985 82.3735 53.3425C82.1267 52.6999 81.6917 52.1468 81.1254 51.7556C80.5591 51.3643 79.8879 51.1531 79.1996 51.1496Z",
    fill: "#E6E4E2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1146 56.2416C63.6097 56.4975 59.3624 63.8506 59.0755 74.1182C59.0125 74.8309 59.11 75.5487 59.3609 76.2187C59.6119 76.8888 60.0099 77.494 60.5256 77.99C61.8085 79.0916 63.656 79.2319 65.2764 79.1068C70.5713 78.7049 75.0165 76.2396 78.5653 72.382C81.2817 69.4284 83.3934 65.4624 85.9526 62.5387C87.4156 60.8642 88.9381 59.264 90.5202 57.738C90.9122 57.3719 91.1963 56.9053 91.3416 56.3889C91.5267 55.762 91.4811 55.0895 91.2131 54.4933C90.9451 53.8971 90.4725 53.4166 89.8808 53.1388C88.5073 52.4539 86.9488 52.2328 85.439 52.5084C81.6404 53.2084 78.6132 55.5159 77.6331 61.4734",
    fill: "#E6E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1146 56.2416C63.6097 56.4975 59.3624 63.8506 59.0755 74.1182C59.0125 74.8309 59.11 75.5487 59.3609 76.2187C59.6119 76.8888 60.0099 77.494 60.5256 77.99C61.8085 79.0916 63.656 79.2319 65.2764 79.1068C70.5713 78.7049 75.0165 76.2396 78.5653 72.382C81.2817 69.4284 83.3934 65.4624 85.9526 62.5387C87.4156 60.8642 88.9381 59.264 90.5202 57.738C90.9122 57.3719 91.1963 56.9053 91.3416 56.3889C91.5267 55.762 91.4811 55.0895 91.2131 54.4933C90.9451 53.8971 90.4725 53.4166 89.8808 53.1388C88.5073 52.4539 86.9488 52.2328 85.439 52.5084C81.6404 53.2084 78.6132 55.5159 77.6331 61.4734",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1373 51.7855C75.9956 51.7881 74.8814 52.1362 73.9414 52.7841C71.513 54.5168 69.9107 59.0572 70.2693 63.4239",
    fill: "#E6E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1373 51.7855C75.9956 51.7881 74.8814 52.1362 73.9414 52.7841C71.513 54.5168 69.9107 59.0572 70.2693 63.4239",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.792 56.755C44.3685 55.5156 43.5963 54.4248 42.5681 53.6136C41.5399 52.8023 40.2993 52.3051 38.9954 52.1817C37.6915 52.0582 36.3797 52.3137 35.2175 52.9176C34.0553 53.5214 33.092 54.4479 32.4435 55.5858V55.62C33.1751 58.355 35.3221 61.7122 38.0707 61.972C40.8194 62.2318 43.5407 59.3532 44.7852 56.7892L44.792 56.755Z",
    fill: "#FFE5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M45.8517 47.75L49.585 50.3619",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.3639 46.3828L29.1588 48.1264",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M75.9505 4.84273C58.8496 2.67679 50.7536 10.6788 49.1649 21.7547C48.2764 27.9465 51.5657 33.8244 57.2576 37.8913C59.9642 40.3954 55.4999 46.846 52.423 48.2382C52.423 48.2382 62.5684 48.877 66.2736 42.1553C67.7744 42.5812 69.3334 42.9046 70.9479 43.1172C84.28 44.8725 95.9847 39.2081 97.4457 28.1114C98.9068 17.0146 93.2156 7.03029 75.9505 4.84273Z",
    fill: "white",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 207",
    cx: 65.439,
    cy: 25.0816,
    r: 1.9888,
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 208",
    cx: 74.1899,
    cy: 25.0816,
    r: 1.9888,
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 209",
    cx: 82.9405,
    cy: 25.0816,
    r: 1.9888,
    fill: "#868686"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDuei);
export default __webpack_public_path__ + "static/media/EmptyDuei.358911074917086b2f67f6d8fdc62f09.svg";
export { ForwardRef as ReactComponent };